// src/plugins/auth.js

import $axios from '../backend'

export default {
    install(Vue) {
        Vue.prototype.$axios = $axios
    }
}
